import { ClusterMarker, ClusterMarkerProps } from './ClusterMarker';
import { OutletMarker, OutletMarkerProps } from './OutletMarker';

interface Props extends ClusterMarkerProps, OutletMarkerProps {
  isCluster: boolean;
}

export const Marker = (props: Props) => {
  const { isCluster } = props;

  if (!isCluster) return <OutletMarker {...props} />;

  return <ClusterMarker {...props} />;
};
